<div class="dfTableContainer allFilesContainer">
  <div class="filterForm">
    <fieldset>
      <mat-form-field appearance="outline" floatLabel="always" >
        <mat-label>Keyword</mat-label>
        <input matInput class="form-control-textbox" name="filterSearch" [(ngModel)]="queryFilter.MaterialNameKeyword" />
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Type</mat-label>
        <mat-select placeholder="All Types" name="filtermaterialtype" [(ngModel)]="queryFilter.Type">
          <mat-option value="0">All Types</mat-option>
          @for (mt of materialTypes; track mt) {
            <mat-option [value]="mt.id">
              {{mt.type}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Language</mat-label>
        <mat-select placeholder="All Languages" name="filtermateriallanguage" [(ngModel)]="queryFilter.Language">
          <mat-option value="0">All Languages</mat-option>
          @for (lang of materialLanguage; track lang) {
            <mat-option [value]="lang.id">
              {{lang.description}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Tags</mat-label>
        <mat-select placeholder="All Tags" name="filtermaterialtags" [(ngModel)]="queryFilter.Tag">
          <mat-option value="0">All Tags</mat-option>
          @for (tag of Tags; track tag) {
            <mat-option [value]="tag.id">
              {{tag.tagName}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Status</mat-label>
        <mat-select placeholder="All Statuses" name="filtermaterialstatus" [(ngModel)]="queryFilter.Status">
          <mat-option value="0">All Statuses</mat-option>
          @for (ms of materialStatus; track ms) {
            <mat-option [value]="ms.key">
              {{ms.value}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always" class="invisible-field">
        <input matInput />
      </mat-form-field>
    </fieldset>
    <div class="form-buttons">
      <div class="filterButtons">
        <button class="submit-form-button" (click)="search()" #submitButton>Search</button>
        <button class="submit-form-button cancel-button no-margin" (click)="resetFilters()">Reset</button>
      </div>
    </div>
  </div>
  <div class="h-30"></div>
  <div class="tableContents">
    <ng-container #tagContainer *ngTemplateOutlet="tagTable; context: {data: materiallist, headerVisible: true}"></ng-container>
    <mat-paginator #paginator [length]="this.totalRecords" [pageSize]="25" [hidden]="this.totalRecords === 0"
    [pageSizeOptions]="[10, 25, 50]" (page)="handlePageEvent($event)" ariaLabel=''></mat-paginator>
  </div>
</div>


<ng-template #tagTable let-data="data" let-headerVisible="headerVisible">
  <app-no-results #noResults></app-no-results>

  <table mat-table class="fileList primary" [dataSource]="data" [hidden]="data.length === 0">
    <ng-container matColumnDef="checkbox">
      <th mat-header-cell *matHeaderCellDef class="roundedLeft" sortActionDescription="Sort by Name"></th>
      <td mat-cell *matCellDef="let material">
        <mat-checkbox [checked]="isMaterialSelected(material)" (change)="onCheckboxChange(material)" [disabled]="hasEnrolledUsers && material.disabled"></mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef class="roundedLeft" sortActionDescription="Sort by Subject">Material ID</th>
      <td mat-cell *matCellDef="let material">
        {{material.materialId}}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef class="roundedLeft" sortActionDescription="Sort by Name">Material Name</th>
      <td mat-cell *matCellDef="let material">
        <a routerLink="/view-material/{{material.id}}">{{material.materialName}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef class="roundedLeft" sortActionDescription="Sort by Subject">Type</th>
      <td mat-cell *matCellDef="let material">
        {{material.type}}
      </td>
    </ng-container>

    <ng-container matColumnDef="language">
      <th mat-header-cell *matHeaderCellDef class="roundedLeft" sortActionDescription="Sort by Subject">Language</th>
      <td mat-cell *matCellDef="let material">
        {{material.language}}
      </td>
    </ng-container>

    <ng-container matColumnDef="tags">
      <th mat-header-cell *matHeaderCellDef class="roundedLeft" sortActionDescription="Sort by Subject">Tags</th>
      <td mat-cell *matCellDef="let material" style="width: 180px;">
        <ul class="stacked-list">
          @for (tag of material.tags; track tag) {
            <li>
              {{ tag }}
            </li>
          }
        </ul>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef class="roundedLeft with-status" sortActionDescription="Sort by Status">Status <app-information-popup [information]="information"></app-information-popup></th>
      <td mat-cell *matCellDef="let material">
        <app-status-bubble [status]="material.status"></app-status-bubble>
      </td>
    </ng-container>
    @if (headerVisible) {
      <tr mat-header-row *matHeaderRowDef="columnsToDisplay" class="tableHeader"></tr>
    }
    <tr mat-row *matRowDef="let tags; columns: columnsToDisplay"></tr>
  </table>
</ng-template>
